// Filtros de produtos compartilhados entre a página pública de inscrições
// (/inscricoes) e a página exclusiva, não listada no menu
// (/inscricoes-exclusivas).
//
// A regra vive aqui num único lugar para que as duas páginas nunca fiquem
// fora de sincronia: o produto que aparece SÓ na exclusiva é exatamente o
// mesmo que fica escondido na pública.

// Termos que, presentes no subtipo do produto, o marcam como "exclusivo".
// Casa com subtipos como "Colab. e Adol." (Colaboradores e Adolescentes).
export const TERMOS_SUBTIPO_EXCLUSIVO = ["colab", "adol"];

// Normaliza para comparação tolerante (ignora espaços e caixa).
const normalizar = (texto) => String(texto || "").trim().toLowerCase();

const ehExclusivo = (produto) => {
  const subtipo = normalizar(produto?.subtipo);
  return TERMOS_SUBTIPO_EXCLUSIVO.some((termo) => subtipo.includes(termo));
};

// Exibido apenas na página de inscrições EXCLUSIVAS: subtipos de Colab./Adol.
export const apenasProdutosExclusivos = (produto) => ehExclusivo(produto);

// Exibido na página de inscrições GERAIS: tudo, menos os subtipos exclusivos.
export const semProdutosExclusivos = (produto) => !ehExclusivo(produto);
